import ServiceAreasContainer from '../../containers/ServicesAreas';

function ServiceAreas() {
  return <ServiceAreasContainer />;
}

export default ServiceAreas;
